<template>
  <component
    :is="$props.tag"
    v-bind="$attrs"
    v-on="$listeners"
    class="base-icon"
  >
    <b-icon :icon="$props.icon" :font-scale="$props.fontScale"></b-icon>
  </component>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'BaseIcon',
  inheritAttrs: false,
  props: {
    tag: String,
    icon: {
      type: String,
      required: true
    },
    fontScale: [String, Number]
  },
  setup() {
    return {}
  }
})
</script>

<style scoped>
.base-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 0;
}
</style>
